enum MappingsMode {
  conversion = 'conversion',
  event = 'event',
  audience = 'audience',
  attribute = 'attribute',
}

export default MappingsMode;
